/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { getUserByToken } from './core/_requests'
import { useAuth } from './core/Auth'
import { LoadingComponent } from './LoadingComponent'

const AuthLayout = () => {
  const urlParams = new URLSearchParams(window.location.search)
    const token = String(urlParams.get('token'))
    const [isRedirecting, setIsRedirecting] = useState<boolean>(false)
    const {saveAuth, setCurrentUser, logout} = useAuth()

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  useEffect(() => {
      const fetchUser = async () => {
        if (token) {
          try {
            await logout()
            setIsRedirecting(true)
            const {data: user} = await getUserByToken()
            setCurrentUser(user)
            saveAuth(user)
          } catch (error) {
            console.error(error)
            saveAuth(undefined)
          } finally {
            setIsRedirecting(false)
          }
        }
      }
      fetchUser()
    }, [token])

  return (
    <div
      className='d-flex flex-column h-100 w-100 no-repeat bg-size-cover bg-position-center'
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundImage: `url(${toAbsoluteUrl('/media/other/bg3.jpg')})`,
      }}
    >
      {/* begin::Body */}

      {/* begin::Form */}
      <div className='d-flex flex-center flex-column flex-lg-row-fluid h-100 align-items-center'>
        {/* begin::Wrapper */}
        <div className='w-lg-500px p-10 card' style={{backgroundColor: 'rgba(255, 255, 255, .8)'}}>
          <img
            className='mx-auto  '
            src={toAbsoluteUrl('/media/logos/auth-screens2.png')}
            alt=''
            style={{width: '180px'}}
          />
          <div className='separator mb-10 mt-8'></div>

          <Outlet />
          {isRedirecting && <LoadingComponent isRedirecting={isRedirecting} />}
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Form */}
    </div>
  )
}

export {AuthLayout}
